{
  "title": "மின்னிலக்க வடிவில் செய்திகள் - ஒரு நாளுக்கு $0.60 செலுத்தி மின்னிதழைப் பெறுங்கள்.",
  "body": "உங்கள் வசதிக்கேற்ப, தேவைப்படும், விரும்பும் நேரத்தில் தடையின்றி வாசிக்கலாம். ஒப்பந்தம் கிடையாது!",
  "cta": "ஒரு நாளுக்கு $0.60 செலுத்தி வாசிக்கத் தொடங்குங்கள்.",
  "backToPublicationLink": "இப்பொது வேண்டாம்"
}
